import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import Button from '../Button/Button';
import './HeroSlider.css';

/**
 * Componente HeroSlider
 * Slider para la sección hero con navegación automática
 */
const HeroSlider = ({ slides, autoPlayInterval = 5000 }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    // Auto-play
    useEffect(() => {
        if (!isPaused && slides.length > 1) {
            const interval = setInterval(() => {
                setCurrentSlide((prev) => (prev + 1) % slides.length);
            }, autoPlayInterval);

            return () => clearInterval(interval);
        }
    }, [currentSlide, isPaused, slides.length, autoPlayInterval]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const goToPrevious = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToNext = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    if (!slides || slides.length === 0) return null;

    const slide = slides[currentSlide];

    return (
        <div
            className="hero-slider"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div className="hero-slider__content">
                <img className='hero-slider__image' src={slide.image} />
                <div className="container">
                    <div className="hero-slider__text">
                        <h1 className="hero-slider__title animate-fade-in">
                            {slide.title}
                        </h1>
                        <p className="hero-slider__subtitle animate-slide-up">
                            {slide.subtitle}
                        </p>
                        <p className="hero-slider__description animate-slide-up">
                            {slide.description}
                        </p>
                        {slide.buttons && slide.buttons.length > 0 && (
                            <div className="hero-slider__buttons animate-scale-in">
                                {slide.buttons.map((button, index) => (
                                    <Link key={index} to={button.link}>
                                        <Button variant={button.variant} size="lg">
                                            {button.text}
                                        </Button>
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Navigation Arrows */}
            {slides.length > 1 && (
                <>
                    <button
                        className="hero-slider__arrow hero-slider__arrow--left"
                        onClick={goToPrevious}
                        aria-label="Slide anterior"
                    >
                        <IoChevronBack />
                    </button>
                    <button
                        className="hero-slider__arrow hero-slider__arrow--right"
                        onClick={goToNext}
                        aria-label="Siguiente slide"
                    >
                        <IoChevronForward />
                    </button>
                </>
            )}

            {/* Dots Navigation */}
            {slides.length > 1 && (
                <div className="hero-slider__dots">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`hero-slider__dot ${index === currentSlide ? 'hero-slider__dot--active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Ir a slide ${index + 1}`}
                        />
                    ))}
                </div>
            )}

            <div className='hero-slider__figure'>
            </div>
        </div>
    );
};

export default HeroSlider;
